export default "__VITE_ASSET__BOynKuFW__"